<template>
    <div class="video-container">
        <div :class="isPlaying?'over-layer hide':'over-layer'" :style="{backgroundImage: 'url(' + video.imgSrc + ')', backgroundSize: 'cover'}"
             @click="play"></div>

        <video :muted="video.muted"  :autoplay="video.autoplay" :loop="video.loop" :ref="video.ref">
            <source :src="video.videoSrc" type="video/mp4">
        </video>

        <!--<b-embed type="video" aspect="4by3" :autoplay="video.autoplay" :muted="video.muted" :loop="video.loop"-->
                 <!--:ref="video.ref" @click="play">-->
            <!--<source :src="video.videoSrc" type="video/mp4">-->
        <!--</b-embed>-->
    </div>
</template>

<script>
    export default {
        name: 'customVideo',
        props: {
            video: {
                type: Object,
            }
        },
        data() {
            return {
                isPlaying: this.video.autoplay
            }
        },
        methods: {
            play() {
                if (this.isPlaying) {
                    this.$refs[this.video.ref].pause()
                } else {
                    this.$refs[this.video.ref].play()
                }

                this.isPlaying = !this.isPlaying
            },
        },
    }
</script>

<style lang="less" scoped>
    @import "../../assets/style/var";

    .video-container {
        position: relative;

        .over-layer {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 100;
            width: 50px;
            height: 50px;
            border-radius: 100%;
            opacity: .8;
            transition: .3s;
            //box-shadow: 0 0 5px 5px rgba(0,0,0,0.4);

            &.hide {
                opacity: 0;
            }
        }

        video {
            width: 100%;
            object-fit: none;
        }

        .embed-responsive {
            &::before {
                padding-top: 56%;
            }
        }
    }
</style>
